module.exports = __webpack_public_path__ + "img/injection_x2.9fbb60b4.png";